/**
 * Bottom Navigation Component (Web Version) - Luxury Design
 * Maintains identical navigation structure from Mobile-client-core
 * Only UI components are adapted for web - all logic preserved
 */

import { useLocation } from 'react-router-dom';
import { Home, ShoppingCart, Calendar, User } from 'lucide-react';
import useServicesStore from '../stores/servicesStore';
import { useNavigation } from '../shared/hooks/useNavigation';
import { BOTTOM_NAV_CONFIG } from '../shared/navigation';
import ThemeToggle from './ThemeToggle';

const BottomNavigation = () => {
  const location = useLocation();
  const { navigate, buildRoute, isActive } = useNavigation();
  const { selectedServices, getExpandedServicesCount } = useServicesStore();

  // Icon mapping
  const iconMap = {
    'home': Home,
    'cartcheckout': ShoppingCart,
    'appointments': Calendar,
    'profile': User,
  };

  // Navigation items from config with icons and state
  const navItems = BOTTOM_NAV_CONFIG.CLIENT.map(item => ({
    ...item,
    icon: iconMap[item.key] || User,
    isActive: isActive(item.route),
    badge: item.key === 'cartcheckout' && selectedServices.length > 0 ? getExpandedServicesCount() : null
  }));

  const handleNavigation = (route) => {
    navigate(route);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-brand-light dark:bg-brand-dark border-t border-brand-dark/10 dark:border-brand-light/10 z-50 safe-area-bottom">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = item.isActive;

          return (
            <button
              key={item.key}
              onClick={() => handleNavigation(item.route)}
              className={`flex flex-col items-center justify-center flex-1 py-2 relative transition-all duration-300
                ${isActive ? 'bg-brand-dark/5 dark:bg-brand-light/5' : 'hover:bg-brand-dark/5 dark:hover:bg-brand-light/5'}`}
            >
              <div className="relative">
                <IconComponent
                  size={22}
                  strokeWidth={isActive ? 2 : 1.5}
                  className={`transition-all duration-300 ${
                    isActive
                      ? 'text-brand-dark dark:text-brand-light'
                      : 'text-brand-gray-500 dark:text-brand-gray-400'
                  }`}
                />
                {item.badge && (
                  <div className="absolute -top-2 -right-2 bg-brand-dark dark:bg-brand-light text-brand-light dark:text-brand-dark text-xs h-5 w-5 flex items-center justify-center font-bold border border-brand-dark dark:border-brand-light">
                    {item.badge}
                  </div>
                )}
              </div>
              <span
                className={`text-[10px] mt-1.5 tracking-wider uppercase font-medium transition-all duration-300 ${
                  isActive
                    ? 'text-brand-dark dark:text-brand-light'
                    : 'text-brand-gray-500 dark:text-brand-gray-400'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}

        {/* Theme Toggle Button */}
        <div className="flex-shrink-0 px-1">
          <ThemeToggle />
        </div>
      </div>
    </div>
  );
};

export default BottomNavigation;